import React, { useState, useEffect } from "react";
import ForumDiscussion from "./ForumDiscussion";
import Feedback from "./Feedback";
import Articles from "./Articles";
import AvailableLocations from "./AvailableLocations";
import DoctorDetails from "./DoctorDetails";
import { debugLog } from "../../../utils/debug";
import DoctorsList from "./DoctorsList";

// Material-UI imports for better UI
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const tabConfig = (loadtype) => {
    const isHospital = loadtype === 'hospitals';
    return [
        {
            label: isHospital ? "Location" : "Available Locations",
            value: "Available Locations",
            show: true,
        },
        {
            label: isHospital ? "Hospital Details" : "Doctor Details",
            value: "Doctor Details",
            show: true,
        },
        {
            label: isHospital ? "Doctors" : "Forum Discussion",
            value: isHospital ? "Doctors" : "Forum Discussion",
            show: true, // Hidden forum tab
        },
        {
            label: "Articles",
            value: "Articles",
            show: true,
        },
        {
            label: "Feedback",
            value: "Feedback",
            show: true,
        }
    ];
};

const TbesCompont = ({ toggleAdvancedSearch, showcomponents, data, doctorDetails, loadtype }) => {
    debugLog('showcomponents data:', doctorDetails);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (data) {
            setLoading(false);
        }
    }, [data]);

    const tabs = tabConfig(loadtype);
    const visibleTabs = tabs.filter(tab => tab.show);

    // Find the index of the current tab for MUI Tabs (only among visible tabs)
    const currentTabIndex = visibleTabs.findIndex(tab => tab.value === showcomponents);

    // Handle tab change
    const handleTabChange = (event, newValue) => {
        toggleAdvancedSearch(visibleTabs[newValue].value);
    };

    return (
        <Box className="dc-docsingle-holder" sx={{ background: "#fff", borderRadius: '5px', boxShadow: 1, p: 0, mb: 3 }}>
            <Box sx={{ px: 3, pt: 2 }} style={{padding: '0px !important'}}>
                <Tabs
                    value={currentTabIndex === -1 ? 0 : currentTabIndex}
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    aria-label="doctor details tabs"
                    sx={{
                        '& .MuiTabs-indicator': {
                            backgroundColor: '#1976d2',
                            height: 3,
                        },
                        '& .MuiTabs-scrollButtons': {
                            '&.Mui-disabled': {
                                opacity: 0.3,
                            },
                        },
                        '.MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: { xs: 13, sm: 15 },
                            minHeight: 60,
                            minWidth: { xs: 'auto', sm: 0 },
                            padding: { xs: '12px 16px', sm: '12px 24px' },
                            color: '#666',
                            border: 'none',
                            transition: 'all 0.3s ease',
                            whiteSpace: 'nowrap',
                            '&:hover': {
                                color: '#1976d2',
                                backgroundColor: 'transparent',
                            },
                            '&.Mui-selected': {
                                color: '#1976d2',
                                fontWeight: 700,
                                backgroundColor: 'transparent',
                                border: 'none',
                            }
                        }
                    }}
                >
                    {visibleTabs.map((tab, idx) => (
                        <Tab
                            key={tab.value}
                            label={tab.label}
                            id={`doctor-tab-${idx}`}
                            aria-controls={`doctor-tabpanel-${idx}`}
                        />
                    ))}
                </Tabs>
            </Box>
            <Box sx={{ p: { xs: 2, sm: 3 } }}>
                {loading ? (
                    <div className="dc-loading" style={{ textAlign: "center", padding: "32px 0" }}>
                        <span style={{ color: "#1976d2", fontWeight: 500, fontSize: 18 }}>Loading...</span>
                    </div>
                ) : (
                    <>
                        {showcomponents === "Forum Discussion" && <ForumDiscussion data={data} />}
                        {showcomponents === "Feedback" && <Feedback data={data} />}
                        {showcomponents === "Articles" && <Articles data={data} />}
                        {showcomponents === "Available Locations" && <AvailableLocations data={data} />}
                        {showcomponents === "Doctor Details" && (
                            <DoctorDetails data={data} doctorDetails={doctorDetails} loadtype={loadtype} />
                        )}
                        {showcomponents === "Doctors" && <DoctorsList data={data} />}
                    </>
                )}
            </Box>
        </Box>
    );
};

export default TbesCompont;
